import React from "react";
import logger from "../../../../../utils/logger";
import "./styles.css";

const getArray = (arr, id, link) => {
  let brr = [];
  for (let i = 0; i < arr.length; i++) {
    if (i !== id) brr.push(arr[i]);
    else brr.push(link);
  }
  return brr;
};

const addToArray = (arr) => {
  return [...arr, ""];
};

const removeFromArray = (arr, id) => {
  let brr = [];
  for (let i = 0; i < arr.length; i++) {
    if (i !== id) brr.push(arr[i]);
  }
  return brr;
};

const LinksInput = ({ linkArray, setLinkArray }) => {
  logger()(linkArray);
  return (
    <div>
      <div className="input-group mb-4">
        {linkArray &&
          linkArray.map((link, id) => (
            <div className="entry input-group" key={id}>
              <input
                className="form-control"
                required
                type="url"
                placeholder="Enter Link"
                value={link}
                onChange={(e) =>
                  setLinkArray(getArray(linkArray, id, e.currentTarget.value))
                }
              />
              <span className="input-group-btn">
                <button
                  className={`btn btn-${
                    id === linkArray.length - 1 ? "success" : "danger"
                  } btn-add glyphicon`}
                  type="button"
                  onClick={() =>
                    setLinkArray(
                      id === linkArray.length - 1
                        ? addToArray(linkArray)
                        : removeFromArray(linkArray, id)
                    )
                  }
                >
                  <b> {id === linkArray.length - 1 ? "+" : "-"}</b>
                </button>
              </span>
            </div>
          ))}
      </div>
    </div>
  );
};

LinksInput.defaultProps = {};

export default LinksInput;
